export default __webpack_public_path__ + "static/media/crane.abac5968.png";